import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import SegmentItemDetail from '../../SegmentItemDetail/SegmentItemDetail';
import { useTranslate } from '/src/lib/MrTranslate/MrTranslate';
import { activeAdjustedExperienceSelector } from '../../../Experiences/selector';
import { getQuestionNumber } from '/src/lib/utils/helperMethods';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import './OneQuestionAtATime.scss';

const OneQuestionAtATime = (props) => {
  const {segmentsToShow, experienceViewMode, mobileUploadMode, readingModeEnabled, printMode, isLibrary, embedded, activeTopicIdx, nestingLevel, onlyExplanationMode, experienceUser, gradingConfig, showAnnotatorToStudent, isPinnedSegment, parentIdxs} = props;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [qCount, setQCount] = useState(1);
  const mrIntl = useTranslate();
  const location = useLocation();
  
  const experience = useSelector(activeAdjustedExperienceSelector())

  // Handle URL hash for direct navigation to a specific segment
  useEffect(() => {
    if (!location.hash) return;
    
    const questionHashFromUrl = location.hash.split("#")[1];
    if (!questionHashFromUrl) return;
    
    const segmentIdMatch = questionHashFromUrl.match(/item-(\d+)/);
    if (!segmentIdMatch) return;
    
    const segmentIdFromUrl = segmentIdMatch[1];
    const urlSegmentIndex = segmentsToShow.findIndex(
      segment => segment.id === parseInt(segmentIdFromUrl)
    );
    
    if (urlSegmentIndex !== -1) {
      setCurrentIndex(urlSegmentIndex);
    }
  }, [location.hash, segmentsToShow]);
  
  const handleNext = () => {
    if (currentIndex < segmentsToShow.length - 1) {
      setCurrentIndex(currentIndex + 1);
      if(segmentType === "question"){
        setQCount(qCount + 1)
      }
    }
  };
  
  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      if(segmentType === "question" && qCount > 1){
        setQCount(qCount - 1)
      }
    }
  };
  
  if (!segmentsToShow || segmentsToShow.length === 0) {
    return (
      <Card>
        <Typography.Text>{mrIntl("SegmentList.no_data_in_section")}</Typography.Text>
      </Card>
    );
  }
  
  const currentSegment = segmentsToShow[currentIndex];
  const segmentType = currentSegment.segment_type;
  let qNo = 
          (segmentType === "question") 
            ? getQuestionNumber(qCount, nestingLevel) 
            : ""
  const questionType = segmentType === "question" && currentSegment.question_segment_attributes && currentSegment.question_segment_attributes.question_type;
  let thisSegmentParentIdxs = []
  if(parentIdxs){
    thisSegmentParentIdxs = [...parentIdxs]
    thisSegmentParentIdxs.push(qCount - 1)
  }
  
  return (
    <div className={`segment-list-one-question-at-a-time segment-list-item ${questionType === "group" ? "group-question" : ""}`} key={`segment-show-${currentSegment.id}`} id={currentSegment && currentSegment.id && `item-${currentSegment.id}`}>
      <Card 
        title={
          <Row className='segment-list-card-title' justify="space-between">
            <Col>
              <Button 
                type="primary" 
                icon={<LeftOutlined />} 
                onClick={handlePrevious}
                disabled={currentIndex === 0}
              >
                {mrIntl("SegmentList.previous")}
              </Button>
            </Col>
            <Col>
              <Button 
                type="primary" 
                onClick={handleNext}
                disabled={currentIndex === segmentsToShow.length - 1}
              >
                {mrIntl("SegmentList.next")} <RightOutlined />
              </Button>
            </Col>
          </Row>
        }
      >
        <SegmentItemDetail 
          key={`segment-item-detail-${currentSegment.id}`} 
          item={currentSegment} experienceViewMode={experienceViewMode} 
          experience={experience} 
          qNo={qNo} 
          mobileUploadMode={mobileUploadMode}
          readingModeEnabled={readingModeEnabled} 
          printMode={printMode} 
          isLibrary={isLibrary} 
          embedded={embedded} 
          parentIdxs={thisSegmentParentIdxs} 
          activeTopicIdx={activeTopicIdx} 
          nestingLevel={nestingLevel} 
          onlyExplanationMode={onlyExplanationMode} 
          experienceUser={experienceUser} 
          gradingConfig={gradingConfig} 
          showAnnotatorToStudent={showAnnotatorToStudent} 
          isPinnedSegment={isPinnedSegment}
        />
      </Card>
    </div>
  );
};

export default OneQuestionAtATime;
